module.exports = require('./helpers/bundle-url').getBundleURL('9iXDo') + "angus.6d96ae78.jpg" + "?" + Date.now();